/* eslint-disable no-unused-expressions */
import React, { Component } from 'react';
import { asyncConnect } from 'redux-connect';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// import GRHeader from '../../../composnents/GRHeader';
import EventSearchForm from './components/EventSearchForm';
import commonUtil from '../../../utils/commonUtil';
// import SearchResult from './components/SearchResults';
import ApplyCSS from '../../../components/ApplyCSS';

import * as EventCategoryActions from './../../../components/eventcategory/actions';
import * as searchEventActions from './actions';
import * as labelsActions from '../../../components/labels/actions';
import AppEvents from '../../App/AppEvents';
import Tagging from '../../../components/Tagging/Tagging';
//import CSSGate  from '../../../components/cssGate';

// const { loadSearch, applyFilter } = searchEventActions;
const { eventSearchByUserDetails, searchEventByEventId, cleanSearchByUserDetails } = searchEventActions;
const { isEventCategoryLoaded, loadEventCategoryEvent } = EventCategoryActions;
const { isLablesLoaded, loadLables } = labelsActions;
// const applicationRoutes = commonUtil.getApplicationRoutes();
const channel = commonUtil.getChannel();
const isWebDevice = (channel === 'web');
const pageName = 'eventSearchForm';
const applicationRoutes = commonUtil.getApplicationRoutes();

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isEventCategoryLoaded(getState())) {
      return dispatch(loadEventCategoryEvent());
    }
    return undefined;
  },
}, {
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])


class SearchEvent extends Component {
  constructor(props) {
    super(props);
    this.searchEvents = this.searchEvents.bind(this);
    this.changeComponentOnBackButtonClick = this.changeComponentOnBackButtonClick.bind(this);
    this.wapBackButtonEvent = null;
    this.searchResult = [];
    this.products = '';
    this.firstName = '';
    this.lastName = '';
    this.eventDate = '';
    this.eventType = '';
  }

  state = {
    resultsFound: false,
  }

  componentDidMount() {
    this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
    if (this.wapBackButtonEvent) {
      AppEvents.publish(this.wapBackButtonEvent, [this.changeComponentOnBackButtonClick]);
    }
    commonUtil.addTransition();
    const dataLayer = {
      event: 'comprar_para_mesa_de_regalos',
      seccion: 'Mesa de regalos',
      phase: 'Busqueda de mesa',
      step: 'Llegada busqueda de mesa',
    };
    window.dataLayer.push(dataLayer);
  }

  componentWillUnmount() {
    AppEvents.unsubscribe(this.wapBackButtonEvent);
  }

  changeComponentOnBackButtonClick = () => {
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.home));
  }

  searchEvents(eventSerachData) {
    this.props.cleanSearchByUserDetails();
    this.firstName = eventSerachData.firstNameOrNickName;
    this.lastName = eventSerachData.lastNameOrPaternalName;
    this.eventType = eventSerachData.eventType;
    this.eventDate = eventSerachData.eventDate;
    const updatedData = eventSerachData;
    if (eventSerachData && eventSerachData.eventDate) {
      const dateBeforeFormate = eventSerachData.eventDate.split('/');
      updatedData.eventDate = dateBeforeFormate[0] + '-' + dateBeforeFormate[1] + '-' + dateBeforeFormate[2];
    }
    this.props.eventSearchByUserDetails(eventSerachData).then(
      (response) => {
        if (this.props.filterProductSearchResult.totalResultsMatchedCount !== '0' && response.status.status === 'success') {
          this.setState({ resultsFound: true });
          !isWebDevice && browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftTableList));
         this.props.filterProductSearchResult?.events?.length == 1 && browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID : this.props.filterProductSearchResult.events[0].eventId  }));
        } else if (response.status.status === 'failure') {
          this.setState({ resultsFound: false });
          const errormessage = response.status.errorMessage;
          const dataLayer = {
            event: 'alerta',
            seccion: 'Mesa de regalos',
            phase: 'Busqueda de mesa',
            step: 'Busqueda de mesa por nombre',
            mensaje: errormessage.substring(0, 100),
            mensaje_servicio: response.status.status,
            tipo: 'Notificacion',
          };
          window.dataLayer.push(dataLayer);
        }
      },
    );
  }

  render() {
    return (
      <div className="row">
        <Tagging ref={tagging => this.tagging = tagging} />
        <ApplyCSS pageName={pageName} />
        <EventSearchForm
          guestData={this.props.guestData}
          serchEventData={this.searchEvents}
          searchEventById={this.props.searchEventByEventId}
          eventCategoryType={this.props.eventCategoryType}
          filterProductSearchResult={this.props.filterProductSearchResult}
          labels={this.props.lables}
          emptyResultsTable={!this.state.resultsFound}
        />
      </div>);
  }
}

const mapStateToProps = state => ({
  user: state.user.data,
  eventCategoryType: state.eventcategory.data,
  productSearchResult: state.searchResult.productSearchResult,
  filterProductSearchResult: state.searchResult.filterProductSearchResult,
  productPerPageOfPagination: state.searchResult.productPerPageOfPagination,
  guestData: state.searchResult.guestData,
  lables: state.labels.data,
});

const matchDispatchToProps = dispatch => bindActionCreators({
  eventSearchByUserDetails,
  cleanSearchByUserDetails,
  searchEventByEventId }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(SearchEvent);

